import { useQuery } from '@tanstack/react-query';
import { getPaymentFailedInvoiceUrl } from '@services/usersService';
import { useUser } from './useUser';
import { queryKeys } from './queryKeys';

export const usePaymentStatus = () => {
  const { user } = useUser();
  const paymentFailed = !!user?.payment_failed;

  const { data: invoiceUrl } = useQuery({
    queryKey: queryKeys.paymentFailedInvoice,
    queryFn: getPaymentFailedInvoiceUrl,
    enabled: paymentFailed,
    retry: false,
  });

  return { paymentFailed, invoiceUrl: invoiceUrl ?? null };
};
